import { Button, Divider, Stack, ToggleButton, useTheme } from "@mui/material";
import { useStore } from "zustand";
import { BuildingLineTool, ProjectAreaTool, ZoneTool } from "@designboticteam/kolega-3d";
import { ToolControl } from "@designboticteam/react/components";
import { Section } from "@/components/Section";
import { useEngineApi } from "@/engine";
import { NewZoneForm } from "../NewZoneForm";

const ToolsSection = (): React.ReactNode => {
	const theme = useTheme();
	const api = useEngineApi();

	const activeTool = useStore(api.workspace3D.store, (store) => store.tools.activeTool);
	const validationStatus = useStore(api.kolega3D.store, (store) => store.validationStatus);
	const projectArea = useStore(api.kolega3D.store, (store) => store.projectArea);
	const zones = useStore(api.kolega3D.store, (store) => store.zones);

	const isClearDisabled = projectArea === null && zones.length === 0;
	const canCreateZone = validationStatus.isProjectAreaSet === true;
	const isCreatingZone = activeTool === ZoneTool.toolName;

	const toggleCreatingZone = (): void => {
		if (isCreatingZone === true) {
			api.kolega3D.tools.setActiveTool(null);
			return;
		}

		api.kolega3D.tools.setActiveTool(ZoneTool);
	};

	return (
		<Section title="Tools" isCollapsible={true}>
			<Stack direction="column" spacing={2}>
				<ToolControl store={api.workspace3D.store} setActiveTool={api.kolega3D.tools.setActiveTool} label="Set project area" tool={ProjectAreaTool} />

				<ToolControl
					store={api.workspace3D.store}
					setActiveTool={api.kolega3D.tools.setActiveTool}
					label="Draw building line"
					tool={BuildingLineTool}
					isDisabled={validationStatus.isProjectAreaSet === false}
				/>

				<ToggleButton
					disableRipple
					value="create-zone"
					size="small"
					color="mono"
					sx={{ boxShadow: theme.shadows[1], textTransform: "none" }}
					disabled={canCreateZone === false}
					selected={isCreatingZone}
					onChange={toggleCreatingZone}
				>
					Create zone
				</ToggleButton>

				{isCreatingZone === true && <NewZoneForm />}

				<Divider />

				<Button variant="outlined" color="error" size="small" disabled={isClearDisabled} onClick={api.kolega3D.tools.clearAll}>
					Clear
				</Button>
			</Stack>
		</Section>
	);
};

export { ToolsSection };
